import { render, staticRenderFns } from "./AdminTipiStudenteView.vue?vue&type=template&id=4ea2abb8&"
import script from "./AdminTipiStudenteView.vue?vue&type=script&lang=ts&"
export * from "./AdminTipiStudenteView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports